import { createContext } from "common/utils/reactContext";
import { type ArenaObjectType } from "common/types/gqlSchemaTypes";

export type ArenaContextType = Partial<
  Pick<
    ArenaObjectType,
    | "id"
    | "name"
    | "jsqHostname"
    | "packagingEdition"
    | "supportEmail"
    | "supportPhone"
    | "isGpLite"
    | "timezone"
  > & { features: Partial<ArenaObjectType["features"]> } // also not all features are fetched in a query for the current arena // do not require all features to be in the type; useful for testing
>;

const [useArenaContext, ArenaProvider] = createContext<ArenaContextType>();
export { useArenaContext, ArenaProvider };
